import { HttpError, Locale } from '@rd/types';
import { LocaleActions, LocaleActionTypes } from '../actions/locale.actions';

export interface LocaleState {
  selected: Locale | null;
  error: HttpError | null;
}

const initialState: LocaleState = {
  selected: null,
  error: null,
};

export function localeReducer(
  state: LocaleState = initialState,
  action: LocaleActions,
): LocaleState {
  switch (action.type) {
    case LocaleActionTypes.LOAD_LOCALE_SUCCESS:
    case LocaleActionTypes.CHANGE_LOCALE_SUCCESS:
      return {
        ...state,
        selected: action.payload,
        error: null,
      };
    case LocaleActionTypes.CHANGE_LOCALE_FAIL:
    case LocaleActionTypes.LOAD_LOCALE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
